export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Po dokončení obchodu bude uzavřen. Interní prostředky budou převedeny uživateli."])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Jste si jisti, že chcete dokončit obchod?"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ano, dokončit"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ne, ponechat aktivní"])}
}